const Single = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/Suppliers/Single')
const Search = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/Suppliers/Search')

export default [
  {
    path: 'suppliers/create',
    name: 'SuppliersCreate',
    component: Single,
    meta: {
      title: 'Adicionar Fornecedor',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'suppliers',
        action: 'create'
      }
    }
  },
  {
    path: 'suppliers/:id',
    name: 'SuppliersEdit',
    component: Single,
    meta: {
      title: 'Editar Fornecedor',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'suppliers',
        action: 'read'
      }
    }
  },
  {
    path: 'suppliers',
    name: 'SuppliersSearch',
    component: Search,
    meta: {
      title: 'Fornecedores',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'suppliers',
        action: 'read'
      }
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/dashboard/suppliers.js